import {Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'vui-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss']
})
export class TabComponent {
    @HostBinding('class.tabbed') public tabbed: boolean;
    @Input() public title: string;
}
